import { default as ReactAsyncSelect } from 'react-select/async';
import { CustomOption } from '../Select/CustomOption';
import { selectStyles } from '../Select/Select.styles';

const IndicatorSeparator = () => null;

/**
 * @deprecated use CDL ComboBox instead
 */

export const AsyncSearchSelect = (props) => {
    const rerenderValue = props.rerenderValue ?? Math.random();
    const styles = props.styles ?? selectStyles;

    return (
        <ReactAsyncSelect
            key={rerenderValue}
            defaultOptions
            components={{
                Option: CustomOption,
                IndicatorSeparator,
                ...props.components,
            }}
            styles={styles}
            onChange={props.onChange}
            onBlur={props.onBlur}
            loadOptions={props.loadOptions}
            placeholder={props.placeholder}
            value={props.values}
            isMulti={props.isMulti}
            isClearable={props.isClearable}
            isDisabled={props.isDisabled}
            className={props.className}
            required={props.required}
        />
    );
};
